module.exports = __webpack_public_path__ + "img/dom.080e8c0e.svg";